import React from 'react';
import { ResumePage } from './features/resume/pages/ResumePage';

function App() {
  return <ResumePage />;
}

export default App;
